export default "__VITE_ASSET__Bt3_j3rh__"